import { render, staticRenderFns } from "./InvoiceApprovalDialog.vue?vue&type=template&id=728d93b8&"
import script from "./InvoiceApprovalDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceApprovalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports